import { render, staticRenderFns } from "./ProductListingItemCountryFlag.vue?vue&type=template&id=00f24049"
import script from "./ProductListingItemCountryFlag.vue?vue&type=script&lang=js"
export * from "./ProductListingItemCountryFlag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports